import { organizerCreateBarApi, organizerUpdateBarApi } from "../../../api/api";
import {
  formDataContacto,
  formDataCrearBar,
  formDataFotos,
  formDataPoliticas,
  formDataSenaZona,
  hayFotos,
} from "./barPayload";

// Where each optional step lives in the bar form (SECTION_IDS of ReservasOrganizer).
export const SECCION_DEL_FORMULARIO = { contacto: "info", fotos: "info", politicas: "politicas", senaZona: "pago" };

export const crearBar = async (d, opts) => {
  const res = await organizerCreateBarApi(formDataCrearBar(d, opts));
  const bar = res?.data?.info || {};
  const id = bar._id || bar.id;
  if (!id) throw new Error("No pudimos confirmar el bar creado. Revisá la lista de reservas.");
  return { id, bar };
};

// Saves one optional step through the same update endpoint the bar form uses; skipping saves nothing.
export const guardarOpcional = async (paso, d, ctx) => {
  const { id } = ctx;
  switch (paso.id) {
    case "contacto":
      await organizerUpdateBarApi(formDataContacto(id, d));
      return;
    case "fotos":
      if (hayFotos(d)) await organizerUpdateBarApi(formDataFotos(id, d));
      return;
    case "politicas":
      await organizerUpdateBarApi(formDataPoliticas(id, d));
      return;
    case "senaZona":
      await organizerUpdateBarApi(formDataSenaZona(id, d));
      return;
    default:
  }
};
